import Link from 'next/link'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect } from 'react'
import Button from 'components/common/button'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import { BUTTON_TYPES } from 'constants/button'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import StateStorage from 'lib/state-storage'
import { toggleBodyFreezing } from 'lib/utils/common/commonUtils'
import { hasLocizeTranslation } from 'lib/utils/locize'
import PomeloPickUpStep from '../pomelo-pickup-step'
import pomeloPickUpStepList from './const'

const PomeloPickUpModal = ({ t, onClose, isPhone }) => {
  const shop = StateStorage.getShop()
  const language = StateStorage.getLanguage()
  const as = `/${shop}/${language}/ttb-home`
  const href = '/ttb-home'
  const linksEl = React.createRef()

  const handleHideContent = useCallback(
    (e) => {
      if (linksEl.current && !linksEl.current.contains(e.target)) {
        onClose(e)
      }
    },
    [linksEl, onClose],
  )

  useEffect(() => {
    if (!isPhone) {
      document.addEventListener('click', handleHideContent, true)

      return () => {
        document.removeEventListener('click', handleHideContent, true)
      }
    }

    return () => {}
  }, [handleHideContent, isPhone, linksEl])

  useEffect(() => {
    if (isPhone) {
      toggleBodyFreezing(true)

      return () => {
        toggleBodyFreezing(false)
      }
    }

    return () => {}
  }, [isPhone])

  return (
    <div className="pdp__pickup-modal__container" ref={linksEl}>
      <div className="pdp__pickup-modal__header">
        <Icon
          alt="close pickup modal"
          className="pdp__pickup-modal__close"
          src={ICONS.close}
          size={ICON_SIZE.medium}
          onClick={onClose}
        />
        <span className={Typo.subtitle1}>
          {hasLocizeTranslation(
            t,
            'PDP__PICKUP_MODAL_TITLE',
            'How Try First Pay Later Works',
          )}
        </span>
      </div>
      <div className="pdp__pickup-modal__info">
        {pomeloPickUpStepList.map((step) => (
          <PomeloPickUpStep key={step.description.key} step={step} />
        ))}
      </div>
      <div className="pdp__pickup-modal__cta-container">
        <Link href={href} as={as}>
          <Button className="pdp__pickup-modal__cta" type={BUTTON_TYPES.link}>
            {hasLocizeTranslation(t, 'PDP__PICKUP_MODAL_CTA', 'Learn More')}
          </Button>
        </Link>
      </div>
    </div>
  )
}

PomeloPickUpModal.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export { PomeloPickUpModal }

const Extended = withI18next()(PomeloPickUpModal)

export default Extended
